import { StyledCaseStudyItem, Image, CaseStudyTitle, CaseStudyLink, Arrow } from './styles';
import { Text } from '@chakra-ui/react';
interface CaseStudyItem {
    image: {
        url: string;
        alt: string;
    };
    hastags?: string;
    title?: string;
    type?: string;
    link?: {
        label: string;
        href: string;
        target: string;
    };
}

const CaseStudyItem: React.FC<CaseStudyItem> = ({ image, hastags, title, link, type }) => {
    return (
        //TODO  Przepisać na chakra UI
        <StyledCaseStudyItem>
            <Image $type={type || ''} alt={image.alt} src={image.url} />
            {hastags && (
                <Text mt={3} fontWeight={'bold'}>
                    {' '}
                    {hastags}{' '}
                </Text>
            )}

            {type === 'default' && <CaseStudyTitle>“{title}“</CaseStudyTitle>}
            {type === 'default' && (
                <CaseStudyLink href={link?.href} target={link?.target}>
                    {link?.label}
                    <Arrow
                        src="https://www.idosell.com/panel/file-gate.php?id=279923&ext=.svg"
                        alt="Arrow"
                    />
                </CaseStudyLink>
            )}
        </StyledCaseStudyItem>
    );
};

export default CaseStudyItem;
